import { render } from "./AddMailTemplate.vue?vue&type=template&id=632c7f9e"
import script from "./AddMailTemplate.vue?vue&type=script&lang=js"
export * from "./AddMailTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__